import { Link } from 'react-router-dom';
import './ProjectContainer.scss';
import { motion } from 'framer-motion';

export type ProjectContainerProps = ({ src: any, projectType: string, title: string, description: string, rightAlign?: boolean, isLast: boolean });

const ProjectContainer = ({ src, projectType, title, description, rightAlign = false, isLast }: ProjectContainerProps): JSX.Element => {
    return (
        <div className="project-container" id={isLast ? title.replace(/\s/g, '-') : undefined}>
            <div className="scroll-target" id={isLast ? undefined : title.replace(/\s/g, '-')}></div>
            <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ type: 'tween', duration: 0.6 }}>
                <Link className='project-img-container' to={`/projects/${title}`}>
                    <img src={src} alt={title}></img>
                </Link>
            </motion.div>
            <motion.div className="project-text-container"
                style={{ textAlign: rightAlign ? 'right' : 'left' }}
                initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
                transition={{ type: 'tween', duration: 0.6 }}
            >
                <h4>{projectType}</h4>
                <h3>
                    <Link to={`/projects/${title}`}>
                        {title}
                    </Link>
                </h3>
                <p>{description}</p>
            </motion.div>
        </div>
    );
}

export default ProjectContainer;
